import { StationService } from './../../core/services/station.service';
import { MergedStation } from './../model/merged-station.interface';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-badge-station',
  templateUrl: './badge-station.component.html',
  styleUrls: ['./badge-station.component.scss', './badge-station-dark.component.scss']
})
export class BadgeStationComponent implements OnInit, OnChanges {
  @Input() changeClass = false;
  @Input() mergedStation: MergedStation;
  @Input() stationId: string;


  @Input() containsMM: boolean;
  @Input() containsStream: boolean;
  @Input() streamQuant = '0';
  badgeM = 'M';

  constructor(
    private readonly stationService: StationService,
  ) { }

  ngOnInit() {
    if (this.mergedStation) {
      this.setAudioSource(this.mergedStation);
    } else if (this.stationId) {
      this.stationService.findStation(this.stationId).subscribe(station => {
        this.setAudioSource(this.stationService.groupStationByName([station])[0]);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mergedStation && changes.mergedStation.currentValue) {
      this.setAudioSource(changes.mergedStation.currentValue);
    }
  }

  private clean() {
    this.mergedStation = null;
    this.stationId = null;
    this.containsMM = false;
    this.containsStream = false;
  }

  private setAudioSource(station: MergedStation) {
    this.clean();
    if (station) {
      this.mergedStation = station;
      const sourceMediaMonitors = station.stationSources.filter(source => source.shortname === 'MM');
      let quantSources = station.stationSources.length;
      this.containsMM = sourceMediaMonitors.length > 0;

      quantSources = quantSources - sourceMediaMonitors.length;

      if (quantSources > 0) {
        this.containsStream = true;
        this.streamQuant = quantSources === 1 ? 'S' : quantSources.toString();
      }
    }
  }

}
